import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import AudienceBuilder from './AudienceBuilder';

export default function AudienceBuilderWrapper() {
  const [resetKey, setResetKey] = useState(() => uuidv4());

  const resetBuilder = () => setResetKey(uuidv4());

  return <AudienceBuilder key={resetKey} resetBuilder={resetBuilder} />;
}
